import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ButtonLoadingComponent } from './button-loading.component';

const MATERIAL_MODULES = [MatButtonModule, MatProgressSpinnerModule];

@NgModule({
  imports: [CommonModule, ...MATERIAL_MODULES],
  exports: [ButtonLoadingComponent],
  declarations: [ButtonLoadingComponent],
  providers: [],
})
export class AccredibleButtonLoadingComponentModule {}
